let config = {};
/**
 * Gets the configuration embed was initialized with.
 *
 * @returns {@link EmbedConfig} The configuration embed was initialized with.
 * @version SDK: 1.19.0 | ThoughtSpot: *
 * @group Global methods
 */
export const getEmbedConfig = () => config;
/**
 * Sets the configuration embed was initialized with.
 * And returns the new configuration.
 *
 * @param newConfig The configuration to set.
 * @version SDK: 1.27.0 | ThoughtSpot: *
 * @group Global methods
 */
export const setEmbedConfig = (newConfig) => {
    config = newConfig;
    return newConfig;
};
//# sourceMappingURL=embedConfig.js.map